import React, { ReactNode } from 'react';
import cn from 'classnames';

import Typography from './typography';

import '@styles/button.scss';

interface ButtonProps {
  mode: 'primary' | 'secondary' | 'custom';
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  variant?: 'outlined' | 'text' | 'contained';
  disabled?: boolean;
  onClick?: () => void;
  children?: ReactNode;
  className?: String;
  colour?: 'primary' | 'primary-line' | 'alternative' | 'error';
}

export const Button = ({
  size = 'medium',
  variant = 'contained',
  mode = 'primary',
  disabled,
  onClick,
  children,
  className,
  ...props
}: ButtonProps) => {
  return (
    <button
      type="button"
      role="button"
      className={cn({
        button: 'button',
        [`${className}`]: className,
        [`button--${size}`]: size,
        [`button--${mode}`]: mode,
        [variant]: variant,
        ['button--disabled']: disabled,
      })}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      <Typography
        variant="button"
        size="rg"
        colour={mode == 'custom' ? props.colour : 'primary'}
      >
        {children}
      </Typography>
    </button>
  );
};
